/**
 * Global scroll-reveal driver for stock sections on the homepage and the
 * collections index (hero, media-with-content, product-list, main-collection-list,
 * generic section — files this theme doesn't own and shouldn't fork just to
 * add motion hooks).
 *
 * Watches every section wrapper Shopify renders (#shopify-section-*) and
 * adds `.in-view` once it crosses into the viewport. What actually animates,
 * and how, lives entirely in brand-tokens.css scoped per section id — this
 * script only tracks visibility, once. The theme's own custom sections
 * (four-worlds, sardinia-map, trust-points, cta-banner) already use the
 * separate <brand-reveal> element and are untouched by this script.
 */
(function () {
  const sections = document.querySelectorAll(
    '[data-template="index"] [id^="shopify-section-"], [data-template="list-collections"] [id^="shopify-section-"], [data-template="collection"] [id^="shopify-section-"]'
  );
  if (!sections.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    sections.forEach((el) => el.classList.add('in-view'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  sections.forEach((el) => observer.observe(el));

  // Safety net: never let content stay invisible if something upstream goes
  // wrong (slow observer callback, unexpected layout, etc).
  window.setTimeout(() => {
    sections.forEach((el) => el.classList.add('in-view'));
    observer.disconnect();
  }, 4000);
})();
